import { useEffect } from 'react';

import { useAuthContext } from 'src/auth/hooks';
import { usePlatforms } from 'src/hooks/use-platforms';

export const useBootstrapActivePlatformId = () => {
  const { platformId, authenticated, changeActivePlatform } = useAuthContext();
  const { data: platforms = [], isLoading } = usePlatforms();

  useEffect(() => {
    if (!authenticated) return;
    if (platformId) return;
    if (isLoading) return;
    if (platforms.length === 0) return;

    changeActivePlatform(platforms[0]!.id);
  }, [authenticated, changeActivePlatform, isLoading, platformId, platforms]);
};
